/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import Button from "../../../../components/reusable/button";
import { MakePaymentButtonPropTypes } from "../lib/types";

const MakePaymentButton = ({
  prevPaymentError,
  testId,
  updateToastMessage,
}: MakePaymentButtonPropTypes): React.ReactElement => {
  const [fetching, setFetching] = React.useState<boolean>(false);

  const handleMakePaymentClick = async (): Promise<void> => {
    try {
      setFetching(true);
      const response = await API.getChargebeePayNowUrl();
      window.open(response.data.data.payNowUrl);
    } catch (error) {
      datadogRum.addError(error);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate("admin_pages.activity.pay_invoice.error"),
        type: "error",
      });
    } finally {
      setFetching(false);
    }
  };

  return (
    <Button
      disabled={fetching}
      onClick={handleMakePaymentClick}
      size="small"
      testId={testId}
      variant="primary"
    >
      {prevPaymentError
        ? i18n.translate("admin_pages.activity.pay_invoice.retry_payment")
        : i18n.translate("admin_pages.activity.pay_invoice.make_payment")}
    </Button>
  );
};

export default MakePaymentButton;
